import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { AppContexte } from '../../contexts/context'
import { NavLink, useNavigate } from 'react-router-dom'
import { adminUserLink } from '../../constants/endspoints'
import IsEmpty from '../../components/IsEmpty'
import { useInfiniteQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { createUser, deleteUser, fetchUsers, updateUserStatus } from '../../api/user'
import { toast } from 'react-toastify'
import Modal from 'react-responsive-modal'
import { useForm } from 'react-hook-form'

const UserManagementAdmin = () => {

    const { decodedToken } = useContext(AppContexte)
    const {register,formState: { errors },handleSubmit} = useForm();
    const navigate = useNavigate()

    const [selectedUser, setSelectedUser] = useState()
    const [openDelModal, setOpenDelModal] = useState(false)
    const [showInput, setShowInput] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [formData, setFormData] = useState({ name:'', email:'', job:'', plainPassword:'' });


    useEffect(() => {
        if (decodedToken) {
            if (decodedToken?.roles[0] !== "ROLE_ADMIN") {
                navigate(adminUserLink);
            }
        }
    }, [decodedToken, navigate]);


    const queryClient = useQueryClient();



    // Fetch All Emissions
    const { data: usersList, fetchNextPage, hasNextPage, isFetchingNextPage, status: listStatus } = useInfiniteQuery({
        queryKey: ["users"],
        queryFn: fetchUsers,
        getNextPageParam: (lastPage) => lastPage.nextPage,
    });


    const observer = useRef();
    const lastMediaRef = useCallback((node) => {
        if (isFetchingNextPage) return;
        if (!hasNextPage) return;

        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                fetchNextPage(); 
            }
        });

        if (node) observer.current.observe(node);
    }, [isFetchingNextPage, hasNextPage, fetchNextPage]);






    // Mutation pour gérer la suppression
    const toastDel = useRef(null);
    const deleteMutation = useMutation({
        mutationFn: deleteUser,
        onMutate: ()=>{
            toastDel.current = toast.loading("Suppression en cours...", { 
                position: 'top-right',
            });
        },
        onSuccess: (res) => {
            toast.dismiss(toastId.current)
            toastId.current = toast.success(`Utilisateur supprimée avec succès !`, {
                isLoading: false,
                autoClose: 5000,
                closeOnClick: true,
            });
            setSelectedUser()
            setOpenDelModal(false)
            queryClient.invalidateQueries({ queryKey: ["users"] });
            toastDel.current = null;
        },
        onError: (err) => {
            toast.dismiss(toastId.current)
            toastId.current = toast.error( "Une erreur est survenue: "+err.message, {
                isLoading: false,
                hideProgressBar: false,
                closeOnClick: true,
            });
            toastDel.current = null;
        },
    });

    // suppression
    const handleDelete = (userId) => {
        deleteMutation.mutate(userId);
    };






    // Mutation pour gérer le status
    const toastStatus = useRef(null);
    const statusMutation = useMutation({
        mutationFn: (user) => updateUserStatus(user.userId, user.status),
        onMutate: (e)=>{
            toastStatus.current = toast.loading(`${e?.status === true? "Activation":"Désactivation"} en cours...`, { 
                position: 'top-right',
            });
        },
        onSuccess: (res) => {
            toast.dismiss(toastStatus.current);
            toastStatus.current = toast.success(`${res?.data?.status === true ? "Activé": "Desactivé"} avec succès`, {
                isLoading: false,
                autoClose: 5000,
                closeOnClick: true,
            });
            setSelectedUser()
            queryClient.invalidateQueries({ queryKey: ["users"] });
            toastStatus.current = null;
        },
        onError: (err) => {
            toast.dismiss(toastStatus.current);
            toastStatus.current = toast.error("Une erreur est survenue: "+err.message, {
                isLoading: false,
                hideProgressBar: false,
                closeOnClick: true,
            });
            toastStatus.current = null;
        },
    });

    const toggleStatus = (userId, status) => {
        statusMutation.mutate({userId:userId, status:status})
    }






    // Create user
    const toastId = useRef(null);
    const createUserMutation = useMutation({
        mutationFn:  createUser,
        onMutate: ()=>{
            toastId.current = toast.loading("Création en cours...", { 
                position: 'top-right',
            });
        },
        onSuccess: (res) => {
            toast.dismiss(toastId.current)
            toastId.current = toast.success(`Utilisateur "${res?.data?.name}" ajouté avec succès !`, {
                isLoading: false,
                autoClose: 5000,
                closeOnClick: true,
            });
            queryClient.invalidateQueries(['users']);
            setShowPassword(false)
            setShowInput(false)
            setFormData({ name:'', email:'', job:'', plainPassword:'' })
            toastId.current = null;
        },
        onError: (err) =>{
            console.log(err);
            toast.dismiss(toastId.current)
            toastId.current = toast.error("Une erreur est survenue: "+err.message, {
                isLoading: false,
                closeOnClick: true,
                hideProgressBar: false,
            });
            toastId.current = null;
        }
    });


    function submit () {
        createUserMutation.mutate(formData)
    }



    return (
        <div>
            <h1 className='fs-3 fw-bold mb-3'> <NavLink className={'fs-3 fw-bold text-white'} to={adminUserLink}>Gestion</NavLink> / Utilisateurs</h1>

            <div className='bg-black rounded-3 p-2 shadow'>
                <h2 className='fs-5 fw-bold mb-2'>Liste des Utilisateurs</h2>


                <div role='button' onClick={()=>setShowInput(true)} className='d-flex align-items-center flex-grow-0 px-2 py-1 bgcolor-primary rounded-3' style={{ width: 'fit-content' }}>
                    <i className="fa-light fa-square-plus me-2 text-white"></i>
                    <span className=' fs-9s text-white'>Ajouter un utilisateur</span>
                </div>



                {/* Form */}
                <form onSubmit={handleSubmit(submit)} className='mt-2 row justify-content-between align-items-center' style={{display:showInput?"":"none"}}>

                    <div className='col-md-6 col-12'>
                        <div className='inputBox'>
                            <input 
                                {...register("name", {
                                    required: "Le nom est requis" ,
                                    pattern: {
                                        value: /^[A-Za-zÀ-ÖØ-öø-ÿ0-9\s-]+$/,
                                        message: "Uniquement des lettres et des espaces sont autorisés",
                                    },
                                })}  
                                onChange={(e)=>setFormData({ ...formData, name: e.target.value })} 
                                value={formData.name} 
                                type='text' 
                                className='w-100 fs-9s' 
                                autoComplete='new-password'
                                required
                            />
                            <span>Nom</span>
                            <i></i>
                        </div>
                        {errors.name && <span className="fs-8s text-danger">{errors.name.message}</span>}
                    </div>

                    <div className='col-md-6 col-12'>
                        <div className='inputBox'>
                            <input 
                                {...register("email", {
                                    required: "Email est requis",
                                    pattern: {
                                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
                                        message: "Format d'email invalide",
                                    },
                                })}
                                onChange={(e)=>setFormData({ ...formData, email: e.target.value })} 
                                value={formData.email} 
                                type='email' 
                                className='w-100 fs-9s'
                                autoComplete="new-password" 
                                required
                            />
                            <span>Email</span>
                            <i></i>
                        </div>
                        {errors.email && <span className="fs-8s text-danger">{errors.email.message}</span>}
                    </div>

                    <div className='col-md-6 col-12'>
                        <div className='inputBox'>
                            <input 
                                {...register("job", {
                                    required: "Poste requis",
                                    pattern: {
                                        value: /^[A-Za-zÀ-ÖØ-öø-ÿ0-9\s-]+$/,
                                        message: "Uniquement des lettres et des espaces sont autorisés",
                                    },
                                })} 
                                onChange={(e)=>setFormData({ ...formData, job: e.target.value })} 
                                value={formData.job} 
                                type='text' 
                                autoComplete='new-password'
                                className='w-100 fs-9s' 
                                required
                            />
                            <span>Poste</span>
                            <i></i>
                        </div>
                        {errors.job && <span className="fs-8s text-danger">{errors.job.message}</span>}
                    </div>

                    <div className='col-md-6 col-12'>
                        <div className='inputBox'>
                            <input 
                                {...register("password", {
                                    required: "Mot de passe requis",
                                    minLength: {
                                        value: 9,
                                        message: "Doit avoir au moins 09 caractères",
                                    },
                                    pattern: {
                                        value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{9,}$/,
                                        message:
                                            "Minimun 9 caractères, 1 majuscule, 1 miniscule, 1 caractère special",
                                    },
                                })}
                                onChange={(e)=>setFormData({ ...formData, plainPassword: e.target.value })} 
                                value={formData.plainPassword} 
                                type={showPassword?'text':'password'} 
                                autoComplete='new-password'
                                className='w-100 fs-9s' 
                                required
                            />
                            <span>Mot de passe</span>
                            <i></i>
                            <p 
                                role='button' 
                                className={`fa-regular ${showPassword?'fa-eye':'fa-eye-slash'} text-white-50 position-absolute mb-0 fs-9s`} 
                                style={{bottom: "7px", right: "10px", zIndex:"10"}}
                                onClick={()=>setShowPassword(!showPassword)}
                            >
                            </p>
                        </div>
                        {errors.password && <span className="fs-8s text-danger">{errors.password.message}</span>}
                    </div>

                    <div className=' d-flex align-items-center mt-3'>
                        <button 
                            type='reset'
                            onClick={()=>{setShowInput(false); setFormData({ name:'', email:'', job:'', plainPassword:'' })}}
                            className=' d-flex align-items-center px-2 py-1 border bordercolor-primary rounded-2 me-2 submit'
                        >
                            <i className='fa-light fa-cancel fs-9s me-2'></i>
                            <span className='fs-9s'>Annuler</span>
                        </button>
                        <button 
                            type='submit'
                            className=' d-flex align-items-center px-2 py-1 border bordercolor-primary bgcolor-primary rounded-2 submit'
                            disabled={createUserMutation.isPending}
                        >
                            <i className='fa-light fa-square-plus fs-9s me-2'></i>
                            <span className='fs-9s'>{createUserMutation.isPending? "Patientez...": "Ajouter"}</span>
                        </button>
                    </div>
                </form>


                {/* Liste */}
                <div className='mt-4 pt-2 table-responsive'>
                    <table className='table table-dark table-striped table-hover fs-9s align-middle'>
                        <thead>
                            <tr>
                                <th className='fs-9s'>#</th>
                                <th className='fs-9s'>Nom</th>
                                <th className='fs-9s'>Email</th>
                                <th className='fs-9s'>Poste</th>
                                <th className='fs-9s'>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                        {listStatus === "pending" ?
                            [1,2,3,4,5].map((item, index) => (
                                <tr key={index}>
                                    <td className='fs-9s py-1 placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                    <td className='fs-9s py-1 placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                    <td className='fs-9s py-1 placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                    <td className='fs-9s py-1 placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                    <td className='fs-9s py-1 placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                </tr>
                            ))
                            : listStatus === "error" ? 
                                <tr>
                                    <td  colSpan="5" className='w-100'>
                                        <IsEmpty icon={"fa-light fa-circle-exclamation"} message={"Une erreur est survenue"} />
                                    </td>
                                </tr>
                            :usersList?.pages?.flatMap((page, pageIndex) => 
                                ((usersList?.pages?.length <= 1) && !page?.nextPage) ?
                                    <tr>
                                        <td  colSpan="5" className='w-100'>
                                            <IsEmpty icon={"fa-light fa-list-timeline"} message={"Aucun utilisateur enregistrée"} />
                                        </td>
                                    </tr>
                                :page?.data?.map((user, index) => {
                                    const isLastItem = pageIndex === usersList?.pages?.length - 1 && index === page?.data?.length - 1;
                                    return (
                                        <tr key={user.id} ref={isLastItem ? lastMediaRef : null}>
                                            <td className='py-1 fs-9s fw-bold'>{index}</td>
                                            <td className='py-1 '><span className='text-truncate-1 fs-9s'>{user?.name}</span></td>
                                            <td className='py-1 '><span className='text-truncate-1 fs-9s'>{user?.email}</span></td>
                                            <td className='py-1 '><span className='text-truncate-1 fs-9s'>{user?.job}</span></td>
                                            <td className='py-1 fs-9s'>
                                                <div className=' d-flex flex-nowrap align-items-center'>
                                                    <div className="form-check form-switch" title='enable/disable'>
                                                        <input className="form-check-input rounded-pill shadow-none" type="checkbox" role="switch" onChange={()=>toggleStatus(user?.id, !user?.status)} checked={user.status} disabled={statusMutation.isPending} />
                                                    </div>
                                                    <i role='button' onClick={()=>{setSelectedUser(user);setOpenDelModal(true)}} title='delete' className='fa-regular fa-trash-can fs-9s text-danger'></i>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                }).slice(1)
                            )
                        }
                        </tbody>
                    </table>
                </div>
            </div>





            {/* Modal de confirmation supression */}
            <Modal open={openDelModal} onClose={()=>deleteMutation.isPending?null:(setOpenDelModal(false), setSelectedUser())} center focusTrapped={false}>
                <h2 className='fw-bold text-center fs-2 mb-1 text-danger p-2'>Confirmer la suppression</h2>
                <p className='fs-9s mb-0 text-center'>Êtes-vous sûr de vouloir supprimer cet utilisateur ?</p>
                <h3 className='fw-bold text-center fs-4'>{selectedUser?.name}</h3>
                <button className='border-0 rounded bg-danger text-white px-2 py-1 me-2 fs-9s' onClick={()=>handleDelete(selectedUser?.id)} disabled={deleteMutation.isPending}>
                {deleteMutation.isPending ? "Suppression en cours..." : "Confirmer"}
                </button>
                <button className='border border-1 bordercolor-primary rounded bg-transparent text-black fs-9s px-2 py-1' disabled={deleteMutation.isPending} onClick={()=>setOpenDelModal(false)}>Annuler</button>
            </Modal>
        </div>
    )
}

export default UserManagementAdmin